import { z } from 'zod';

const dimensionValue = z.number().min(-1).max(1);

// Migration-only representation of the pre-v0.2 profile. Never use this for new analysis.
export const legacyStyleProfileSchema = z.object({
  schemaVersion: z.literal('0.1'),
  summary: z.string(),
  isMock: z.boolean().optional(),
  traits: z.array(
    z.object({
      id: z.string(),
      label: z.string(),
      confidence: z.number(),
      evidence: z.array(z.string()),
    }),
  ),
  dimensions: z.object({
    minimalExpressive: dimensionValue,
    structuredSoft: dimensionValue,
    classicExperimental: dimensionValue,
    warmCool: dimensionValue,
    naturalPolished: dimensionValue,
    casualFormal: dimensionValue,
    understatedBold: dimensionValue,
    familiarUnconventional: dimensionValue,
    romanticArchitectural: dimensionValue,
    playfulRestrained: dimensionValue,
  }),
  visualSignals: z.object({
    colourTemperature: z.enum(['warm', 'cool', 'balanced', 'unknown']),
    colours: z.array(z.string()),
    materials: z.array(z.string()),
    shapes: z.array(z.string()),
    motifs: z.array(z.string()),
    degreeOfContrast: z.enum(['low', 'moderate', 'high', 'unknown']),
  }),
  uncertainty: z.array(z.string()),
});

export type LegacyStyleProfile = z.infer<typeof legacyStyleProfileSchema>;

